import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-agreements-ceg-fine-print',
  templateUrl: 'agreements-ceg-fine-print.component.html',
  styleUrls: ['agreements-fine-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgreementsCegFinePrintComponent  {
}
